export default __webpack_public_path__ + "static/media/Animals2_11.53f7e8b6.png";